<template>
  <div class="auth-reset">
    <div class="auth-reset__logo">
      <img src="@/assets/img/auth-logo.svg" alt="Altezza Travel">
    </div>
    <h1 class="auth-reset__title">{{ $t('auth.newPinTitle') }}</h1>
    <p class="auth-reset__description">
      {{ $t('auth.newPinDescription') }}
    </p>
    <form v-if="!complete" class="auth-reset__form" @submit.prevent="submit">
      <app-form-group :label="$t('auth.newPin')" label-for="new-pin">
        <app-input
          id="new-pin"
          v-model="pin"
          type="password"
          inputmode="numeric"
          maxlength="6"
          autocomplete="new-password"
        />
      </app-form-group>
      <app-form-group :label="$t('auth.confirmPin')" label-for="confirm-pin">
        <app-input
          id="confirm-pin"
          v-model="pinConfirm"
          type="password"
          inputmode="numeric"
          maxlength="6"
          autocomplete="new-password"
        />
        <template #error>
          <div v-if="pinConfirm && pin !== pinConfirm">{{ $t('auth.pinMismatch') }}</div>
        </template>
      </app-form-group>
      <p v-if="invalidLink" class="auth-reset__error">
        {{ $t('auth.invalidLink') }}
      </p>
      <app-button ref="submit" type="submit" :disabled="!canSubmit">
        {{ $t('auth.changePin') }}
      </app-button>
    </form>
    <p v-else class="auth-reset__result">
      {{ $t('auth.changed') }}
    </p>
    <router-link
      class="auth-reset__back"
      :to="{name: invalidLink ? 'forgot-password' : 'login'}"
    >
      {{ invalidLink ? $t('auth.requestNewLink') : $t('auth.backToLogin') }}
    </router-link>
  </div>
</template>

<script>
import {confirmPersonalCabinetPasswordReset} from '@/http'

export default {
  name: 'ResetPassword',
  data() {
    return {
      pin: '',
      pinConfirm: '',
      complete: false,
      invalidLink: !this.$route.query.token,
    }
  },
  computed: {
    canSubmit() {
      return /^\d{6}$/.test(this.pin) && this.pin === this.pinConfirm && !this.invalidLink
    },
  },
  methods: {
    submit() {
      if (!this.canSubmit) return
      this.$refs.submit.preload = true
      confirmPersonalCabinetPasswordReset({
        token: this.$route.query.token,
        pin: this.pin,
        pin_confirm: this.pinConfirm,
      })
        .then(() => {
          this.complete = true
        })
        .catch(error => {
          if (error.response && error.response.status === 400) this.invalidLink = true
        })
        .finally(() => {
          if (this.$refs.submit) this.$refs.submit.preload = false
        })
    },
  },
}
</script>

<style lang="sass" scoped>
.auth-reset
  display: flex
  flex-direction: column
  align-items: center
  width: 100%

.auth-reset__logo
  margin-bottom: 54px
  line-height: 0

.auth-reset__title
  margin-bottom: 12px
  font-size: 28px

.auth-reset__description, .auth-reset__result
  max-width: 320px
  margin-bottom: 28px
  color: #666
  font-size: 14px
  line-height: 1.5
  text-align: center

.auth-reset__form
  display: flex
  flex-direction: column
  align-items: center
  width: 100%
  max-width: 300px

  .form-group
    width: 100%

.auth-reset__error
  margin: -6px 0 20px
  color: $color-error
  font-size: 13px
  line-height: 1.4
  text-align: center

.auth-reset__back
  margin-top: 24px
  color: $color-theme
  font-size: 13px
</style>
